import React, { useState } from 'react'
import {
  Flex,
  Text,
  Button,
  useToast,
  Box,
  HStack,
  VStack
} from '@chakra-ui/react'
import { WorksheetIcon } from '@blueprinthq/joy'

import { useHistory } from 'react-router-dom'
import { useSessionControllerCreateSampleSession } from '@core/api'
import { useQueryClient } from 'react-query'

import { endpoints } from '@api'

export const SampleSessionsModule = ({ isGetStarted }) => {
  const toast = useToast()
  const history = useHistory()
  const [loadingStates, setLoadingStates] = useState({})
  const queryClient = useQueryClient()

  const {
    mutateAsync: executeCreateSampleSession
  } = useSessionControllerCreateSampleSession()

  const createSampleSession = async sampleType => {
    setLoadingStates(prevStates => ({
      ...prevStates,
      [sampleType]: true
    }))

    try {
      const response = await executeCreateSampleSession({
        data: { sampleType }
      })

      queryClient.invalidateQueries(
        endpoints.getClinicianDashboardSessions.getCacheId()
      )

      history.push(
        `/patient/${response.clientId}/completed-session/${response.sessionId}?isDemo=true`
      )
    } catch (err) {
      toast({
        title: 'Error',
        description: 'There was an error creating the sample progress note.',
        status: 'error',
        duration: 3000,
        isClosable: true
      })
    }

    setLoadingStates(prevStates => ({
      ...prevStates,
      [sampleType]: false
    }))
  }

  const Samples = () => (
    <>
      <Button
        id="pendo-sessions-sample-intake"
        variant="link"
        isLoading={loadingStates.intake}
        color="black"
        onClick={() => createSampleSession('intake')}
        ml={0}
        mr="small"
      >
        Intake Note
      </Button>
      <Button
        id="pendo-sessions-sample-cbt"
        variant="link"
        isLoading={loadingStates.cbt}
        color="black"
        onClick={() => createSampleSession('cbt')}
        ml={0}
        mr="small"
      >
        CBT Progress Note
      </Button>
      <Button
        id="pendo-sessions-sample-dbt"
        variant="link"
        isLoading={loadingStates.dbt}
        color="black"
        onClick={() => createSampleSession('dbt')}
        ml={0}
        mr="small"
      >
        DBT Progress Note
      </Button>
      <Button
        id="pendo-sessions-sample-emdr"
        variant="link"
        isLoading={loadingStates.emdr}
        color="black"
        onClick={() => createSampleSession('emdr')}
        ml={0}
      >
        EMDR Progress Note
      </Button>
    </>
  )

  const GetStartedSampleSessions = () => (
    <HStack spacing={2}>
      <Flex justify="center" align="center" h="36px" w="36px" mr="4px">
        <WorksheetIcon fill="#4366EA" height="36px" width="36px" />
      </Flex>
      <VStack spacing={0} alignItems="flex" justifyContent="flex-start">
        <Text fontWeight="bold">
          See an example AI generated progress note:
        </Text>
        <Flex justify="flex-start" flexWrap="wrap">
          <Samples />
        </Flex>
      </VStack>
    </HStack>
  )

  return (
    <Box
      p="small"
      width="100%"
      borderRadius="8px"
      border="1px solid #E4E5E6"
      mb="small"
    >
      {isGetStarted ? (
        <GetStartedSampleSessions />
      ) : (
        <VStack spacing={1} alignItems="flex" justifyContent="flex-start">
          <Text fontWeight="bold" align="center">
            See an example AI generated progress note:
          </Text>
          <Flex justify="center" flexWrap="wrap">
            <Samples />
          </Flex>
        </VStack>
      )}
    </Box>
  )
}
